import {
  gqlFilterOperator,
  gqlProfileStatusSearchEnum,
  gqlTalentUnionEnum as TALENT_UNION,
  gqlWillingnessEnum as WILLINGNESS,
} from '@minecraft.graphql-types';
import { FilterDrawerType } from '../types';
import { initialRadioButtonSkillLevelValue, emptyOption } from '../../../shared/config';
import { FiltersNameEnum, RangeEnum, SizesChildrenCategoryEnum } from '../../../shared/types';
import { repsCommonInitialData } from './repsInitialData';

export const initialFilters = {
  // Initial form values of Casting
  [FilterDrawerType.Casting]: {
    [FiltersNameEnum.autofillByRoleCriteria]: false,
    // Basic filters
    [FiltersNameEnum.stageName]: '',
    [FiltersNameEnum.gender]: [],
    [FiltersNameEnum.additionallyIdentifiesAs]: [],
    [FiltersNameEnum.ethnicAppearance]: [],
    [FiltersNameEnum.playableAgeRange]: {
      [FiltersNameEnum.switchTo]: false,
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
      type: RangeEnum.age as RangeEnum.age,
    },
    [FiltersNameEnum.minorsAgeRange]: {
      [FiltersNameEnum.switchTo]: false,
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
      type: RangeEnum.age as RangeEnum.age,
    },
    [FiltersNameEnum.workingLocation]: [],
    [FiltersNameEnum.primaryWorkingLocation]: [],
    // Unions And Reps
    [FiltersNameEnum.nonUnion]: false,
    [FiltersNameEnum.unionStatus]: [],
    [FiltersNameEnum.excludeUnionStatus]: [],
    [FiltersNameEnum.talentType]: [
      { value: FiltersNameEnum.represented, key: 'common:filtersName.represented' },
      { value: FiltersNameEnum.unrepresented, key: 'common:filtersName.unrepresented' },
    ],
    [FiltersNameEnum.representatives]: [],
    [FiltersNameEnum.representativeList]: [],
    // Custom
    [FiltersNameEnum.isNewTalent]: false,
    // Appearances
    [FiltersNameEnum.heightRange]: {
      [FiltersNameEnum.switchTo]: false,
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.height, // need to build pill of height range
    },
    [FiltersNameEnum.weightRange]: {
      [FiltersNameEnum.switchTo]: false,
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.weight, // need to build pill of weight range
    },
    [FiltersNameEnum.hairColor]: [],
    [FiltersNameEnum.willingToHairColor]: false,
    [FiltersNameEnum.hairStyle]: [],
    [FiltersNameEnum.willingToHairStyle]: false,
    [FiltersNameEnum.facialHair]: [],
    [FiltersNameEnum.willingToFacialHair]: false,
    [FiltersNameEnum.eyeColor]: [],
    [FiltersNameEnum.tattoosList]: [],
    [FiltersNameEnum.tattoosNote]: '',
    [FiltersNameEnum.piercingsList]: [],
    [FiltersNameEnum.piercingsNote]: '',
    [FiltersNameEnum.uniqueAttributes]: [],
    [FiltersNameEnum.multipleBirth]: [],
    [FiltersNameEnum.otherExperience]: '',
    [FiltersNameEnum.pregnancyDueDateRange]: {
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
      type: RangeEnum.date, // need to build pill of age range
    },
    // Role Preferences
    [FiltersNameEnum.rolePreferences]: [],
    // Clothing Sizes
    [FiltersNameEnum.sizesCategory]: emptyOption,
    [FiltersNameEnum.sizesChildrenCategory]: {
      value: SizesChildrenCategoryEnum.boys,
      label: 'Boys',
    },
    [FiltersNameEnum.chest]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.neck]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.sleeve]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.coat]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.waist]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.inseam]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.glove]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.hat]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.menTShirt]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.menShoes]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.menShoeWidth]: emptyOption,
    [FiltersNameEnum.dress]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.bust]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.underbust]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.cup]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.hip]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.womenPants]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.womenTShirt]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.womenShoes]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.womenShoeWidth]: emptyOption,
    [FiltersNameEnum.boys]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.girls]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.toddlers]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.infants]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.childrenShoes]: {
      [FiltersNameEnum.min]: emptyOption,
      [FiltersNameEnum.max]: emptyOption,
      type: RangeEnum.size,
    },
    [FiltersNameEnum.childrenShoeWidth]: emptyOption,
    // Skills And Assets
    [FiltersNameEnum.skills]: [],
    [FiltersNameEnum.skillLevels]: initialRadioButtonSkillLevelValue,
    [FiltersNameEnum.skillOperator]: {
      value: gqlFilterOperator.OR,
      label: 'Any',
    },
    [FiltersNameEnum.dogBreed]: [],
    [FiltersNameEnum.dogBreedSize]: '',
    [FiltersNameEnum.otherAnimals]: [],
    [FiltersNameEnum.props]: [],
    [FiltersNameEnum.sportsEquipment]: [],
    [FiltersNameEnum.wardrobe]: [],
    [FiltersNameEnum.profession]: '',
    [FiltersNameEnum.vehicleType]: emptyOption,
    [FiltersNameEnum.vehicleYearRange]: {
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
    },
    [FiltersNameEnum.vehicleMake]: emptyOption,
    [FiltersNameEnum.vehicleModel]: '',
    [FiltersNameEnum.additionalWorkingLocation]: [],
    // Documents
    [FiltersNameEnum.documents]: [],
  },
  // Initial form values of Reps
  [FilterDrawerType.Reps]: {
    ...repsCommonInitialData,
    [FiltersNameEnum.autofillByRoleCriteria]: false,
    [FiltersNameEnum.profileStatus]: { value: gqlProfileStatusSearchEnum.CURRENT, label: 'Current Clients' },
    [FiltersNameEnum.realAgeRange]: {
      [FiltersNameEnum.switchTo]: false,
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
      type: RangeEnum.age,
    },
    // Exclude Talent With
    [FiltersNameEnum.excludeConflicts]: [],
    [FiltersNameEnum.excludeBookedOutDates]: {
      [FiltersNameEnum.min]: '',
      [FiltersNameEnum.max]: '',
      type: RangeEnum.date, // need to build pill of age range
    },
  },
  // Initial form values for Talent Scout
  [FilterDrawerType.TalentScout]: {
    ...repsCommonInitialData,
    [FiltersNameEnum.stageName]: '',
    [FiltersNameEnum.unionStatus]: [],
    [FiltersNameEnum.gender]: [],
    [FiltersNameEnum.ethnicAppearance]: [],
    [FiltersNameEnum.playableAgeRange]: {
      [FiltersNameEnum.min]: 0,
      [FiltersNameEnum.max]: 0,
      [FiltersNameEnum.switchTo]: false,
    },
    [FiltersNameEnum.seekingRepresentation]: [],
    [FiltersNameEnum.workingLocation]: [],
  },
};

// a list of size range filters that are cleared when the size category is changed
export const clearableSizesRangeFilters = [
  FiltersNameEnum.chest,
  FiltersNameEnum.neck,
  FiltersNameEnum.sleeve,
  FiltersNameEnum.coat,
  FiltersNameEnum.menTShirt,
  FiltersNameEnum.menShoes,
  FiltersNameEnum.menShoeWidth,
  FiltersNameEnum.dress,
  FiltersNameEnum.bust,
  FiltersNameEnum.underbust,
  FiltersNameEnum.cup,
  FiltersNameEnum.hip,
  FiltersNameEnum.womenPants,
  FiltersNameEnum.womenTShirt,
  FiltersNameEnum.womenShoes,
  FiltersNameEnum.womenShoeWidth,
  FiltersNameEnum.sizesChildrenCategory,
  FiltersNameEnum.boys,
  FiltersNameEnum.girls,
  FiltersNameEnum.toddlers,
  FiltersNameEnum.infants,
  FiltersNameEnum.childrenShoes,
  FiltersNameEnum.childrenShoeWidth,
];

// a list of size range filters that are cleared when the children size category is changed
export const clearableChildrenSizesRangeFilters = [
  FiltersNameEnum.boys,
  FiltersNameEnum.girls,
  FiltersNameEnum.toddlers,
  FiltersNameEnum.infants,
];

export const sagAftraChildren = [TALENT_UNION.ELIGIBLE, TALENT_UNION.FICORE, TALENT_UNION.MEMBER];

export const willingnessesWhiteList = [
  WILLINGNESS.REVEAL_APPEAR_IN_LINGERIE_OR_SWIMSUIT,
  WILLINGNESS.REVEAL_CROSS_DRESS,
  WILLINGNESS.REVEAL_SEMI_NUDE,
  WILLINGNESS.REVEAL_NUDE,
  WILLINGNESS.OTHER_KISSING_SCENE,
  WILLINGNESS.OTHER_SAME_SEX_KISSING_SCENE,
  WILLINGNESS.EXTRAS_WORK,
  WILLINGNESS.OTHER_SEXUAL_SITUATIONS,
  WILLINGNESS.OTHER_SMOKE,
  WILLINGNESS.ANIMALS_WORK_WITH_DOGS,
  WILLINGNESS.ANIMALS_WORK_WITH_CATS,
  WILLINGNESS.OTHER_EAT_MEAT,
];
